import styled from '@emotion/styled';
import { css } from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';
import React, { type ComponentProps } from 'react';
import { compose, variant } from 'styled-system';

type Props = {
  orientation?: 'vertical' | 'holizonal';
  minWidth?: string;
};

const TabsRoot = styled('div', {
  shouldForwardProp,
})<Props>(
  () =>
    css({
      display: 'flex',
    }),
  ({ theme }) =>
    compose(
      variant({
        prop: 'orientation',
        variants: {
          holizonal: css({
            flexDirection: 'row',
            boxShadow: `inset 0 -1px 0 ${theme.colors.border.grey}`,
          }),
          vertical: css({
            flexDirection: 'column',
            borderRight: theme.borders.grey,
          }),
        },
      }),
    ),
);

export const Tabs = ({ orientation = 'holizonal', ...rest }: ComponentProps<typeof TabsRoot>) => (
  <TabsRoot orientation={orientation} {...rest} />
);
